import React from "react";
import { Helmet } from "react-helmet-async";

export interface BlogPostSEOProps {
  title: string;
  description: string;
  image: string;
  datePublished: string;
  author: string;
  url: string;
}

const BlogPostSEO: React.FC<BlogPostSEOProps> = ({ title, description, image, datePublished, author, url }) => (
  <Helmet>
    <title>{title} | SortMyShoebox Blog</title>
    <meta name="description" content={description} />

    {/* Open Graph */}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:type" content="article" />
    <meta property="og:url" content={url} />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />

    {/* Structured Data (JSON-LD) */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: title,
        description: description,
        image: image,
        author: {
          "@type": "Person",
          name: author
        },
        datePublished: datePublished,
        publisher: {
          "@type": "Organization",
          name: "SortMyShoebox"
        },
        url: url
      })}
    </script>
  </Helmet>
);

export default BlogPostSEO;
